import type {AppState} from '@auth0/auth0-react';

/**
 * The SDK's default `onRedirectCallback` only rewrites the URL bar via raw
 * `history.replaceState`, which a data router (`createBrowserRouter`) doesn't react to —
 * routing back to `appState.returnTo` requires going through the router's own `navigate`.
 */
export function createRouterRedirectCallback(
  navigate: (to: string, options?: {replace?: boolean; flushSync?: boolean}) => unknown
): (appState?: AppState) => void {
  return appState => {
    // A transition would lose to the gate's urgent signed-in render, letting the `/` redirect run first.
    void navigate(appState?.returnTo ?? '/', {replace: true, flushSync: true});
  };
}
